import { AlmeState } from "@alme/ui-web/wireup/AlmeState";
import { Store } from "redux";
import { settings } from '@alme/ui-web/settings/settings-util';
import {waitForIvaFunction} from '../lib-alight-library/lib-alight-library';
import * as Actions from './actions/actions';
import * as Reducers from './reducers/index';


export default class ProcessLocale
{
    _settings: typeof settings;
    _store: Store<AlmeState> | undefined;

    constructor(passedSettings: typeof settings){
        this._settings = passedSettings;
    }

    initialize(store: Store<AlmeState>){   
        this._store = store;     
    }

    getReducer(){
        return Reducers.reducer;
    }

    getPromise(){
        return this.startProcessLocale();
    }

    startProcessLocale(): Promise<any>
    {
        waitForIvaFunction().then((result) =>{
            let locale;
            if(window.enableIVAasService){
                let initData = window.enableIVAasService();
                if(initData?.locale){
                    locale = initData.locale;
                }
                else{
                    return Promise.resolve();
                }
            }
            else if(window.enableIVA2Features){
                const productPayload = window.enableIVA2Features();
                const configData = productPayload.generalConfigData || {};
                if(configData?.locale){
                    locale = configData.locale;
                }
                else{
                    return Promise.resolve();
                }
            }
            else{
                return Promise.resolve();
            }
            const convertedLocale = locale.replace('_', '-');
            const baseLocale = this._settings.stateLocations.Conversation.language;
            
            if(baseLocale === convertedLocale){
                return Promise.resolve();
            }
            
            const base = this._settings.stateLocations.Conversation.Base;
            const location = this._settings.stateLocations.Conversation.language;
            const langStateLocation = `${base}.${location}`;

            this._store?.dispatch(Actions.saveLocale(langStateLocation, convertedLocale));
        });
        return Promise.resolve();
    }
}


// WEBPACK FOOTER //
// ./modules/process-locale/process-locale.ts